import { panes } from '../getPanes';

describe('getPanes', () => {
  it('should return an array of panes', () => {
    expect(panes()).toEqual(expect.any(Array));
  });
});
